import axios from 'axios';
import api from '../../config.json'
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import validation from '../../utill/validation';
import joi from 'joi'
import Loading from '../../utill/LoadingComponent';
import { Select } from 'antd';

const InstrumentForm = ({ history, Heading }) => {
    const [formData, setFormData] = useState({});
    const [content, setContent] = useState("");
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [types, setAllTypes] = useState([]);
    const handleOnChange = (name, value) => {
        const obj = { ...formData };
        obj[name] = value;
        const error = validation.validateProperty({ name: name, value: value }, schema)
        setErrors(error || {})
        setFormData(obj);
    }

    const location = useLocation();
    useEffect(() => {
        Heading('Instrument Master Form')
    }, [])

    useEffect(() => {
        getAllTypes()
        if (location.state && location.state.action == 'update') {
            setFormData(location.state.data)
        }
    }, [location])

    const schema = {
        InstrumentType: joi.required().label('Instrument Type'),
        Instrument: joi.string().label('Instrument'),
        _id: joi.string()
    }

    const getAllTypes = () => {
        setLoader(true)
        axios.get(api.api + 'instrumentType')
            .then((result) => {
                setAllTypes(result.data.map(x => { return { label: x.InstrumentType, value: x.InstrumentType, _id: x._id } }))
                setLoader(false)
            })
            .catch((err) => {
                swal(`${err}`);
                setLoader(false)
            })
    }



    const handleSave = () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        const error = validation.validate(formData, schema)
        if (error) {
            setErrors(error)
            return
        }
        setErrors(error || {})
        setLoader(true)
        if (location.state && location.state.action == "update") {
            axios.patch(api.api + 'instrument/' + formData._id, formData)
                .then((result) => {
                    swal('Update Successfully');
                    history.push('/setting/instrument/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(`${err.response.data.message}`, { dangerMode: true });
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        } else {
            axios.post(api.api + 'instrument', formData)
                .then((result) => {
                    swal('Save Successfully');
                    history.push('/setting/instrument/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(`${err.response.data.message}`, { dangerMode: true });
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        }

    }
    return (

        <React.Fragment>
            {/* <div className='text-center'>
                <p>Instrument Master Form</p>
            </div> */}
            {loader ? <Loading /> : <></>}
            <div className="row ">
                <div className='col-sm-3'></div>
                <div className='col-sm-3 text-center mt-1'>
                    <label>Instrument Type</label>
                    <Select
                        // maxTagCount='responsive'
                        //mode="multiple"
                        placeholder="Select Customer"
                        value={formData.InstrumentType || ""}
                        onChange={(values) => {
                            handleOnChange('InstrumentType', values)
                        }}
                        style={{ width: '100%' }}
                        options={types}
                    />
                </div>
                <div className="col-sm-4 ">
                    <div className="form-group text-center">
                        <label htmlFor="componentid">Instrument</label>
                        <input
                            value={formData.Instrument || ""}
                            className="form-control form-control-sm"
                            required
                            type="text"
                            onChange={(e) => handleOnChange('Instrument', e.currentTarget.value)}
                            name="Instrument"
                            placeholder="Enter instrument name..."
                        />
                    </div>
                    {errors.Instrument && <div className="alert small alert-danger">{errors['Instrument']}</div>}
                </div>
            </div>
            <div className='row text-center mt-2'>
                <div className='col-sm-12'>
                    <button onClick={handleSave} className="btn-sm btn-primary">Submit</button>
                    <button onClick={() => history.push('/setting/instrument/list')} className="btn-sm btn-primary ml-4">Cancel</button>
                </div>
            </div>
        </React.Fragment>
    );
}

export default InstrumentForm;